/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContratInfosForSuiviDto
 */
export interface ContratInfosForSuiviDto {
    /**
     * 
     * @type {number}
     * @memberof ContratInfosForSuiviDto
     */
    idmetier?: number;
    /**
     * 
     * @type {number}
     * @memberof ContratInfosForSuiviDto
     */
    idlieuFormation?: number;
}

/**
 * Check if a given object implements the ContratInfosForSuiviDto interface.
 */
export function instanceOfContratInfosForSuiviDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratInfosForSuiviDtoFromJSON(json: any): ContratInfosForSuiviDto {
    return ContratInfosForSuiviDtoFromJSONTyped(json, false);
}

export function ContratInfosForSuiviDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratInfosForSuiviDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
    };
}

export function ContratInfosForSuiviDtoToJSON(value?: ContratInfosForSuiviDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idmetier': value.idmetier,
        'idlieuFormation': value.idlieuFormation,
    };
}

